var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:Object.assign({}, _vm.props.classes, {'text-danger': _vm.props.value.length > _vm.props.limit })},[_vm._v("\r\n    "+_vm._s(_vm.props.value.length)+" / "+_vm._s(_vm.props.limit)+"\r\n")])}
var staticRenderFns = []

export { render, staticRenderFns }